export enum ContactFolderType{
    /**
     * Database 버전 개인 연락처
     */
    PC,
    /**
     * 부서 연락처
     */
    DC,
    /**
     * 공용 연락처
     */
    Public,
    /**
     * Exchange 버전 개인 연락처
     */
    Personal,
    /**
     * 즐겨찾기한 연락처
     */
    Favorite,
    /**
     * 공유받은 연락처
     */
    Shared,
    /**
     * 공유한 연락처
     */
    Sharing
}

export enum ContactsStoredType{
    /**
     * database 버전
     */
    DB,
    /**
     * exchage 버전
     */
    EWS
}

export enum ShareType{
    notShared,
    shared
}

export enum PublicSearchConditions{
    UserName,
    UserId
}